/** City Projects listing — tabs aligned with GET /api/v1/admin/projects. */

export const CITY_PROJECT_STATUS_TABS = [
  { key: "all", label: "All" },
  { key: "present", label: "Present" },
  { key: "past", label: "Past" },
  { key: "future", label: "Future" },
]
